// Shared wood/case color themes used across cozy furniture components
// (TBR bedside table, main bookshelf, etc). Extracted so every themed
// piece of furniture in the app stays visually in sync — add a new
// theme here once and it shows up everywhere.
export const WOOD_THEMES = {
  darkWood: {
    label: 'Dark Wood',
    surface: '#8d6e63', drawer: '#795548', leg: '#5d4037', knob: '#d7ccc8',
    spines: ['#8fbc8f', '#b0c4de', '#d8bfd8', '#ffb6c1', '#ffe4e1'],
    spineText: '#3e2723'
  },
  lightPine: {
    label: 'Light Pine',
    surface: '#d7b98e', drawer: '#c9a876', leg: '#a8875f', knob: '#6d4c41',
    spines: ['#7ba05b', '#6a8caf', '#b087b8', '#e08a9b', '#d9a066'],
    spineText: '#33251c'
  },
  whitePainted: {
    label: 'White Painted',
    surface: '#f0eae2', drawer: '#e4dccf', leg: '#cfc5b8', knob: '#8d6e63',
    spines: ['#87a96b', '#8fa8c8', '#c39bd3', '#e59aa8', '#e8c07d'],
    spineText: '#3e2f23'
  },
  mahogany: {
    label: 'Mahogany',
    surface: '#6d3a2d', drawer: '#5a2f24', leg: '#43231b', knob: '#e8d5c4',
    spines: ['#a3b18a', '#a9c0d8', '#d4b8dc', '#f0b7c3', '#f2d5b8'],
    spineText: '#2e1a12'
  },
  obsidian: {
    label: 'Obsidian',
    surface: '#3a3a3f', drawer: '#2c2c30', leg: '#1e1e21', knob: '#b0a99f',
    spines: ['#5e8d6a', '#5b7fa6', '#8d6fa8', '#b56a7d', '#b8894f'],
    spineText: '#f5efe6'
  }
};

export const DEFAULT_WOOD_THEME_KEY = 'darkWood';
